import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';
import SkeletonCard from '../../components/Redesing/skeleton/SkeletonCard';

/**
 * Skeleton component for the maintenance log detail page.
 * Mirrors the single-column layout with a Task Details card.
 */
function TaskDetailSkeleton() {
  return (
    <Box sx={{ p: { xs: 1, sm: 2 } }}>
      <Stack spacing={3}>
        {/* Back link */}
        <Stack direction="row" alignItems="center" spacing={1}>
          <Skeleton variant="circular" width={20} height={20} />
          <Skeleton variant="text" width={120} height={24} />
        </Stack>

        {/* Header: icon, title, chip */}
        <Stack sx={{ pl: 2 }} spacing={0.5}>
          <Stack
            alignItems="flex-start"
            direction={{ xs: 'column', md: 'row' }}
            justifyContent="space-between"
            spacing={2}
          >
            <Stack alignItems="center" direction="row" spacing={2}>
              <Skeleton variant="circular" width={64} height={64} />
              <Stack spacing={1}>
                <Skeleton variant="text" width={280} height={32} />
                <Stack alignItems="center" direction="row" spacing={1}>
                  <Skeleton variant="text" width={50} height={20} />
                  <Skeleton
                    variant="rectangular"
                    width={120}
                    height={24}
                    sx={{ borderRadius: 1 }}
                  />
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Stack>

        {/* Task Details card */}
        <SkeletonCard title rows={8} />
      </Stack>
    </Box>
  );
}

export default TaskDetailSkeleton;
